import { useEffect, useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import inventoryApi from '../../api/inventoryApi';

const PieChart = () => {
  const [data, setData] = useState({
    labels: [],
    datasets: [],
    assessments: [],
    totalBranches: [],
  });

  const fetchData = async () => {
    const result = await inventoryApi.fetchBranchWiseCount();
    
    const labels = result?.map((item) => item.name) || [];
    const students = result?.map((item) => Number(item.total_students)) || [];
    const assessments = result?.map((item) => Number(item.total_assessments)) || [];
    const totalBranches = result?.map((item) => Number(item.total_branches)) || [];

    setData({
      labels,
      datasets: [
        {
          label: 'Total Students',
          data: students,
          backgroundColor: [
            'rgba(252,76,122,1)','rgba(255,99,71,1)','rgba(160,160,140,1)','rgba(41,187,213,1)',
            'rgba(65,241,99,1)','rgba(70,70,255,1)','rgba(186,104,200,1)','rgba(52,152,219,1)',
            'rgba(230,126,34,1)','rgba(26,188,156,1)','rgba(231,76,60,1)','rgba(142,68,173,1)',
            'rgba(52,73,94,1)','rgba(241,196,15,1)','rgba(255,165,0,1)','rgba(0,191,255,1)',
            'rgba(127,255,0,1)','rgba(255,20,147,1)','rgba(138,43,226,1)','rgba(60,179,113,1)',
            'rgba(255,105,180,1)','rgba(70,130,180,1)','rgba(255,215,0,1)','rgba(100,149,237,1)',
            'rgba(210,105,30,1)'
          ],
          borderColor: [
            'rgba(252,76,122,1)','rgba(255,99,71,1)','rgba(160,160,140,1)','rgba(41,187,213,1)',
            'rgba(65,241,99,1)','rgba(70,70,255,1)','rgba(186,104,200,1)','rgba(52,152,219,1)',
            'rgba(230,126,34,1)','rgba(26,188,156,1)','rgba(231,76,60,1)','rgba(142,68,173,1)',
            'rgba(52,73,94,1)','rgba(241,196,15,1)','rgba(255,165,0,1)','rgba(0,191,255,1)',
            'rgba(127,255,0,1)','rgba(255,20,147,1)','rgba(138,43,226,1)','rgba(60,179,113,1)',
            'rgba(255,105,180,1)','rgba(70,130,180,1)','rgba(255,215,0,1)','rgba(100,149,237,1)',
            'rgba(210,105,30,1)'
          ],
          borderWidth: 1,
        },
      ],
      assessments,
      totalBranches,
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  ChartJS.register(ArcElement, Tooltip, Legend);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'top' },
      tooltip: {
        callbacks: {
          label: function(context) {
            const index = context.dataIndex;
            const branch = context.chart.data.labels[index];
            const students = context.dataset.data[index];
            const assessments = context.chart.data.assessments[index];
            const branches = context.chart.data.totalBranches[index];

            return `${branch}: Students ${students}, Assessments ${assessments}, Branches ${branches}`;
          },
        },
      },
    },
  };

  return <Pie data={data} options={options} />;
};

export default PieChart;
